import React, { useEffect, useRef } from "react";
import { useWindowBreakpoints } from "../../custom-hooks/useWindowBreakpoints";
import { Modal } from "reactstrap";
import { useProdesegDropdownContext } from "./ProdesegDropdownContextProvider";
import { ReactComponent as IconCerrar } from "../../assets/img/icon/icon_cerrar_verde.svg";
import { ClickableDiv } from "../ClickableDiv";
import { DISPLAY_NAME_DROPDOWN_MENU, FIRST_TIME_LOGIN } from "./prodeseg-dropdown.constants";
import { ProdesegButton, ProdesegButtonEnumSizes, ProdesegButtonEnumTypes } from "../ProdesegButton/ProdesegButton";
import { ReactComponent as IconClose } from "../../assets/img/icon/menu/cerrar.svg";

const ICON_SIZE = "16px";
const ICON_POSITION = "8px";

export const ProdesegDropdownMenu: React.FC<{
    className?: string;
    showCloseButton?: boolean;
    children?: React.ReactNode | null;
    initialIsOpen?: boolean;
    iconCloseStyle?: React.CSSProperties;
    iconCloseButtonType?: ProdesegButtonEnumTypes;
    activateModal?: boolean;
}> = ({
    className = "",
    showCloseButton = false,
    iconCloseStyle,
    children,
    iconCloseButtonType,
    initialIsOpen,
    activateModal,
}) => {
    const { isDownSm } = useWindowBreakpoints();
    const { value, setFalse, setTrue } = useProdesegDropdownContext();
    const isFirstRender = useRef(true);
    const timeoutId = useRef(0);

    useEffect(() => {
        if (!initialIsOpen || !isFirstRender.current) return;
        setTrue();
        timeoutId.current = window.setTimeout(() => sessionStorage.removeItem(FIRST_TIME_LOGIN), 5000);
    }, []);

    useEffect(() => {
        if (value || isFirstRender.current) return;
        clearTimeout(timeoutId.current);
    }, [value]);

    useEffect(() => {
        isFirstRender.current = false;
    }, []);

    if (!children) return <></>;

    if (isDownSm || activateModal)
        return (
            <Modal isOpen={value} modalClassName={"prodeseg-dropdown-modal"}>
                <ClickableDiv onClick={setFalse} cursor>
                    <IconCerrar
                        width={ICON_SIZE}
                        height={ICON_SIZE}
                        className={"position-absolute"}
                        style={{
                            top: ICON_POSITION,
                            right: ICON_POSITION,
                        }}
                    />
                </ClickableDiv>
                <div className={`prodeseg-overflow-auto prodeseg-bg-white ${className}`}>{children}</div>
            </Modal>
        );

    return (
        <div className={`prodeseg-dropdown__menu__content shadow-lg ${className}`}>
            {showCloseButton && (
                <ProdesegButton
                    type={iconCloseButtonType ?? ProdesegButtonEnumTypes.Dark}
                    size={ProdesegButtonEnumSizes.Small}
                    Icon={IconClose}
                    isOutline
                    onlyIcon
                    onClick={setFalse}
                    className={"border-0 position-absolute"}
                    style={
                        iconCloseStyle ?? {
                            right: "24px",
                            top: "24px",
                        }
                    }
                />
            )}
            {children}
        </div>
    );
};

ProdesegDropdownMenu.displayName = DISPLAY_NAME_DROPDOWN_MENU;
